module.exports = __webpack_public_path__ + "static/img/6.7f0aedc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/zh/6.png
// module id = JO+Q
// module chunks = 0